import type { ReactNode } from "react";

export type ChipItem<T extends string | number> = {
  key: T; label: ReactNode; note?: ReactNode;
  // Optional stable selector for chips whose accessible name isn't a clean
  // test target (e.g. a `note` renders inline and gets folded into the
  // button's accessible name) — M6 line-mode station chips are the first
  // caller that needs this; everything else keeps matching on role+label.
  testId?: string;
};

export function ChipGrid<T extends string | number>({
  items, activeKey, onSelect, tall, trailing,
}: {
  items: ChipItem<T>[];
  activeKey?: T | null;
  onSelect: (key: T) => void;
  tall?: boolean;
  trailing?: ReactNode;
}) {
  return (
    <div className="chip-grid">
      {items.map((it) => (
        <button
          key={String(it.key)}
          type="button"
          data-testid={it.testId}
          className={`chip${tall ? " chip-tall" : ""}${activeKey === it.key ? " active" : ""}`}
          onClick={() => onSelect(it.key)}
        >
          {it.label}
          {it.note ? <span className="chip-note">{it.note}</span> : null}
        </button>
      ))}
      {trailing}
    </div>
  );
}
